import React, { FC } from 'react';
import styled from 'styled-components';

import { TinkoffMethod } from '~/api/finance/financeApiTypes';
import {
  DefaultMethodPaymentParams,
  MethodPaymentTemplate,
} from '~/feature/finance/BuyingSteps/ChoosePay/MethodPayments/MethodPaymentTemplate';

interface TinkoffMethodPaymentProps extends DefaultMethodPaymentParams {
  method: TinkoffMethod;
  isHide?: boolean;
}

export const TinkoffMethodPayment: FC<TinkoffMethodPaymentProps> = ({
  method,
  onCheck,
  isHide = false,
  ...props
}) => {
  if (isHide) {
    return <></>;
  }

  return (
    <MethodPaymentTemplate
      Logo={(
        <SCIcon
          src="/icon/components/TinkoffMethodPayment/tinkoff.svg"
        />
      )}
      Text={(
        <>
          Карты РФ и СНГ, T-pay
        </>
      )}
      onCheck={() => {
        if (onCheck) {
          onCheck(method);
        }
      }}
      {...props}
    />
  );
};

const SCIcon = styled.img`
  width: 148px;
`;
